module.exports = ".test {\n    position: relative;\n    display: block;\n    margin: 2em auto;\n    padding: 2em;\n}\n\n* {\n    margin: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/test/test.component.css
// module id = ./src/app/core/components/test/test.component.css
// module chunks = main